// extracted by mini-css-extract-plugin
export var border = "_g-8";
export var brand = "_g-t";
export var button = "_g-l";
export var center = "_g-a";
export var centered = "_g-6";
export var closeButton = "_g-c";
export var disabledWrapper = "_g-m";
export var error = "_g-p";
export var extraLarge = "_g-4";
export var extraSmall = "_g-1";
export var fill = "_g-i";
export var footer = "_g-h";
export var footerAction = "_g-j";
export var footerButtons = "_g-k";
export var header = "_g-7";
export var headerWithClose = "_g-d";
export var icon = "_g-o";
export var info = "_g-s";
export var inline = "_g-9";
export var large = "_g-3";
export var main = "_g-e";
export var modal = "_g-0";
export var nearFull = "_g-5";
export var neutral = "_g-u";
export var noPadding = "_g-g";
export var none = "_g-v";
export var scrollable = "_g-f";
export var small = "_g-2";
export var success = "_g-r";
export var tight = "_g-n";
export var titleIcon = "_g-b";
export var warn = "_g-q";